import { v4 as uuidv4 } from 'uuid';

export const APPLICATION_ID = uuidv4();

let merchantID = '';

export const getGlobalMerchantId = () => {
  return merchantID;
};

export const setGlobalMerchantId = (id: string) => {
  merchantID = id;
};
